// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_math = require("rescript/lib/js/js_math.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Rect$SmartcutsMacros = require("./Rect.bs.js");
var DOM__Shadow$SmartcutsMacros = require("./DOM__Shadow.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var DOM__EventType$SmartcutsMacros = require("./DOM__EventType.bs.js");
var DOM__DataTransfer$SmartcutsMacros = require("./DOM__DataTransfer.bs.js");

var $$CustomEvent = {};

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "height",
                Decco.intToJson(v.height)
              ],
              [
                "top",
                Decco.floatToJson(v.top)
              ],
              [
                "width",
                Decco.intToJson(v.width)
              ],
              [
                "left",
                Decco.floatToJson(v.left)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
  if (height.TAG === /* Ok */0) {
    var top = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "top"), null));
    if (top.TAG === /* Ok */0) {
      var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
      if (width.TAG === /* Ok */0) {
        var left = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "left"), null));
        if (left.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    height: height._0,
                    top: top._0,
                    width: width._0,
                    left: left._0
                  }
                };
        }
        var e = left._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".left" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = width._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".width" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = top._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".top" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = height._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".height" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function fromElement(element) {
  return {
          height: element.scrollHeight,
          top: element.scrollTop,
          width: element.scrollWidth,
          left: element.scrollLeft
        };
}

function fromHtmlElement(element) {
  return {
          height: element.scrollHeight,
          top: element.scrollTop,
          width: element.scrollWidth,
          left: element.scrollLeft
        };
}

var ScrollInfo = {
  t_encode: t_encode,
  t_decode: t_decode,
  fromElement: fromElement,
  fromHtmlElement: fromHtmlElement
};

function fromEventTarget(target) {
  if (target === window) {
    return {
            TAG: /* TargetWindow */0,
            _0: window
          };
  } else if (target === document) {
    return {
            TAG: /* TargetDocument */1,
            _0: document
          };
  } else {
    return {
            TAG: /* TargetElement */2,
            _0: target
          };
  }
}

var TypedEventTarget = {
  fromEventTarget: fromEventTarget
};

function parentGeometry_encode(v) {
  return Js_dict.fromArray([
              [
                "width",
                Decco.intToJson(v.width)
              ],
              [
                "height",
                Decco.intToJson(v.height)
              ]
            ]);
}

function parentGeometry_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
  if (width.TAG === /* Ok */0) {
    var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
    if (height.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                width: width._0,
                height: height._0
              }
            };
    }
    var e = height._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".height" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = width._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".width" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "x",
                Decco.intToJson(v.x)
              ],
              [
                "y",
                Decco.intToJson(v.y)
              ],
              [
                "parent",
                parentGeometry_encode(v.parent)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
  if (x.TAG === /* Ok */0) {
    var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
    if (y.TAG === /* Ok */0) {
      var parent = parentGeometry_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parent"), null));
      if (parent.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  x: x._0,
                  y: y._0,
                  parent: parent._0
                }
              };
      }
      var e = parent._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".parent" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = y._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".y" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = x._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".x" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromMouseEvent($$event) {
  var target = $$event.target;
  var targetElement = fromEventTarget(target);
  switch (targetElement.TAG | 0) {
    case /* TargetWindow */0 :
    case /* TargetDocument */1 :
        break;
    case /* TargetElement */2 :
        var targetElement$1 = targetElement._0;
        var targetRect = target.getBoundingClientRect();
        var targetClientX = targetRect.left;
        var targetClientY = targetRect.top;
        return {
                x: Js_math.floor($$event.clientX - targetClientX),
                y: Js_math.floor($$event.clientY - targetClientY),
                parent: {
                  width: targetElement$1.clientWidth,
                  height: targetElement$1.clientHeight
                }
              };
    
  }
  return {
          x: $$event.clientX | 0,
          y: $$event.clientY | 0,
          parent: {
            width: window.innerWidth,
            height: window.innerHeight
          }
        };
}

function getClientXYForDifferentParentInstance(parent, param) {
  var match = param.parent;
  var rect = parent.getBoundingClientRect();
  var newParentClientX = rect.left;
  var newParentClientY = rect.top;
  var newParentWidth = rect.width;
  var newParentHeight = rect.height;
  var xRatio = param.x / match.width;
  var yRatio = param.y / match.height;
  var newClientX = newParentClientX + xRatio * newParentWidth | 0;
  var newClientY = newParentClientY + yRatio * newParentHeight | 0;
  return [
          newClientX,
          newClientY
        ];
}

var PositionRelToElement = {
  parentGeometry_encode: parentGeometry_encode,
  parentGeometry_decode: parentGeometry_decode,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromMouseEvent: fromMouseEvent,
  getClientXYForDifferentParentInstance: getClientXYForDifferentParentInstance
};

function parentGeometry_encode$1(v) {
  return Js_dict.fromArray([
              [
                "width",
                Decco.intToJson(v.width)
              ],
              [
                "height",
                Decco.intToJson(v.height)
              ],
              [
                "scroll",
                t_encode(v.scroll)
              ]
            ]);
}

function parentGeometry_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
  if (width.TAG === /* Ok */0) {
    var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
    if (height.TAG === /* Ok */0) {
      var scroll = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scroll"), null));
      if (scroll.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  width: width._0,
                  height: height._0,
                  scroll: scroll._0
                }
              };
      }
      var e = scroll._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".scroll" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = height._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".height" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = width._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".width" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "x",
                Decco.intToJson(v.x)
              ],
              [
                "y",
                Decco.intToJson(v.y)
              ],
              [
                "parent",
                parentGeometry_encode$1(v.parent)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
  if (x.TAG === /* Ok */0) {
    var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
    if (y.TAG === /* Ok */0) {
      var parent = parentGeometry_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parent"), null));
      if (parent.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  x: x._0,
                  y: y._0,
                  parent: parent._0
                }
              };
      }
      var e = parent._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".parent" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = y._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".y" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = x._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".x" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromMouseEvent$1($$event) {
  var target = $$event.target;
  var targetElement = fromEventTarget(target);
  switch (targetElement.TAG | 0) {
    case /* TargetWindow */0 :
    case /* TargetDocument */1 :
        break;
    case /* TargetElement */2 :
        var targetElement$1 = targetElement._0;
        var targetRect = target.getBoundingClientRect();
        var targetClientX = targetRect.left;
        var targetClientY = targetRect.top;
        return {
                x: Js_math.floor($$event.clientX - targetClientX),
                y: Js_math.floor($$event.clientY - targetClientY),
                parent: {
                  width: targetElement$1.clientWidth,
                  height: targetElement$1.clientHeight,
                  scroll: fromElement(targetElement$1)
                }
              };
    
  }
  return {
          x: $$event.clientX | 0,
          y: $$event.clientY | 0,
          parent: {
            width: window.innerWidth,
            height: window.innerHeight,
            scroll: fromElement(document.documentElement)
          }
        };
}

function getClientXYForDifferentParentInstance$1(parent, param) {
  var match = param.parent;
  var rect = parent.getBoundingClientRect();
  var newParentClientX = rect.left;
  var newParentClientY = rect.top;
  var newParentWidth = rect.width;
  var newParentHeight = rect.height;
  var xRatio = param.x / match.width;
  var yRatio = param.y / match.height;
  var newClientX = newParentClientX + xRatio * newParentWidth | 0;
  var newClientY = newParentClientY + yRatio * newParentHeight | 0;
  return [
          newClientX,
          newClientY
        ];
}

var PositionRelToElementWithScrollInfo = {
  parentGeometry_encode: parentGeometry_encode$1,
  parentGeometry_decode: parentGeometry_decode$1,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromMouseEvent: fromMouseEvent$1,
  getClientXYForDifferentParentInstance: getClientXYForDifferentParentInstance$1
};

var $$MouseEvent = {};

var $$InputEvent = {};

var $$ClipboardEvent = {};

var $$KeyboardEvent = {};

var $$DragEvent = {};

var $$FocusEvent = {};

var BlurEvent = {};

var $$WheelEvent = {};

function stringify(param) {
  return "{target, clipboardWhenOpened: " + (StringUtils$SmartcutsMacros.quote(param.clipboardWhenOpened) + (", clipboardWhenClosed: " + (StringUtils$SmartcutsMacros.quote(param.clipboardWhenClosed) + ")")));
}

var ContextMenuClosed = {
  stringify: stringify
};

function stringify$1(v) {
  return "ContentMenuClosed(" + (stringify(v._0) + ")");
}

var SyntheticEvent = {
  ContextMenuClosed: ContextMenuClosed,
  stringify: stringify$1
};

function boundingClientRectGet($$event) {
  var boundingRectFromEventTarget = function (domEvent) {
    var eventTarget;
    switch (domEvent.TAG | 0) {
      case /* WheelEvent */5 :
          eventTarget = undefined;
          break;
      case /* FocusEvent */6 :
      case /* BlurEvent */7 :
          eventTarget = Caml_option.some(domEvent._1.target);
          break;
      case /* ChangeEvent */8 :
          eventTarget = Caml_option.some(domEvent._0.target);
          break;
      case /* SyntheticEvent */10 :
          eventTarget = Caml_option.some(domEvent._0._0.target);
          break;
      default:
        eventTarget = Caml_option.some(domEvent._1.target);
    }
    var targetElementFromEventTaraget = function (eventTarget) {
      switch (eventTarget.TAG | 0) {
        case /* TargetWindow */0 :
        case /* TargetDocument */1 :
            return DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
        case /* TargetElement */2 :
            return Caml_option.some(eventTarget._0);
        
      }
    };
    return OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.map(Belt_Option.flatMap(OptionUtils$SmartcutsMacros.map(eventTarget, fromEventTarget), targetElementFromEventTaraget), (function (prim) {
                      return prim.getBoundingClientRect();
                    })), Rect$SmartcutsMacros.fromDomRect);
  };
  var maybeSelection = window.getSelection();
  var selection;
  switch ($$event.TAG | 0) {
    case /* MouseEvent */0 :
        if ($$event._0 !== "click") {
          return boundingRectFromEventTarget($$event);
        }
        var mouseEvent = $$event._1;
        var exit = 0;
        if (maybeSelection == null) {
          exit = 2;
        } else {
          if (mouseEvent.target.isContentEditable && maybeSelection.rangeCount > 0) {
            var range = maybeSelection.getRangeAt(0);
            var rectFromSelectionRange = Rect$SmartcutsMacros.fromDomRect(range.getBoundingClientRect());
            if (Rect$SmartcutsMacros.isEmpty(rectFromSelectionRange)) {
              return boundingRectFromEventTarget($$event);
            } else {
              return rectFromSelectionRange;
            }
          }
          exit = 2;
        }
        if (exit === 2) {
          var match = fromEventTarget(mouseEvent.target);
          var exit$1 = 0;
          switch (match.TAG | 0) {
            case /* TargetWindow */0 :
            case /* TargetDocument */1 :
                exit$1 = 3;
                break;
            case /* TargetElement */2 :
                return boundingRectFromEventTarget($$event);
            
          }
          if (exit$1 === 3) {
            var x0 = mouseEvent.clientX;
            var y0 = mouseEvent.clientY;
            return Rect$SmartcutsMacros.withPadding(50, {
                        x: x0,
                        y: y0,
                        width: 0.0,
                        height: 0.0
                      });
          }
          
        }
        break;
    case /* InputEvent */1 :
        if ($$event._0 !== "input") {
          return boundingRectFromEventTarget($$event);
        }
        if (maybeSelection == null) {
          return boundingRectFromEventTarget($$event);
        }
        selection = maybeSelection;
        break;
    case /* ClipboardEvent */3 :
        var match$1 = $$event._0;
        if (!(match$1 === "paste" || match$1 === "copy")) {
          return boundingRectFromEventTarget($$event);
        }
        if (maybeSelection == null) {
          return boundingRectFromEventTarget($$event);
        }
        selection = maybeSelection;
        break;
    case /* Event */9 :
        if ($$event._0 !== "selectionchange") {
          return boundingRectFromEventTarget($$event);
        }
        if (maybeSelection == null) {
          return boundingRectFromEventTarget($$event);
        }
        selection = maybeSelection;
        break;
    default:
      return boundingRectFromEventTarget($$event);
  }
  if (selection.rangeCount <= 0) {
    return boundingRectFromEventTarget($$event);
  }
  var range$1 = selection.getRangeAt(0);
  var rectFromSelectionRange$1 = Rect$SmartcutsMacros.fromDomRect(range$1.getBoundingClientRect());
  if (Rect$SmartcutsMacros.isEmpty(rectFromSelectionRange$1)) {
    return boundingRectFromEventTarget($$event);
  } else {
    return rectFromSelectionRange$1;
  }
}

function stringify$2($$event) {
  switch ($$event.TAG | 0) {
    case /* MouseEvent */0 :
        return "MouseEvent(" + (DOM__EventType$SmartcutsMacros.mouseToJs($$event._0) + ", mouseEvent)");
    case /* InputEvent */1 :
        var arg = Belt_Option.map(Caml_option.nullable_to_opt($$event._1.data), StringUtils$SmartcutsMacros.quote);
        return "InputEvent(" + (DOM__EventType$SmartcutsMacros.inputToJs($$event._0) + (", inputEvent(data=" + ((function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })("undefined") + "))")));
    case /* KeyboardEvent */2 :
        var code = $$event._1.code;
        return "KeyboardEvent(" + (DOM__EventType$SmartcutsMacros.keyboardToJs($$event._0) + (", keyboardEvent={code: " + (code + "})")));
    case /* ClipboardEvent */3 :
        return "ClipboardEvent(" + (DOM__EventType$SmartcutsMacros.clipboardToJs($$event._0) + (", clipboardEvent=" + (DOM__DataTransfer$SmartcutsMacros.getData("text", $$event._1.clipboardData) + ")")));
    case /* DragEvent */4 :
        return "DragEvent(" + (DOM__EventType$SmartcutsMacros.dragToJs($$event._0) + ", dragEvent)");
    case /* WheelEvent */5 :
        return "WheelEvent(" + (DOM__EventType$SmartcutsMacros.wheelToJs($$event._0) + ", wheelEvent)");
    case /* FocusEvent */6 :
        return "FocusEvent(" + (DOM__EventType$SmartcutsMacros.focusToJs($$event._0) + ", focusEvent)");
    case /* BlurEvent */7 :
        return "BlurEvent(" + (DOM__EventType$SmartcutsMacros.blurToJs($$event._0) + ", blurEvent)");
    case /* ChangeEvent */8 :
        return "ChangeEvent(event, " + (StringUtils$SmartcutsMacros.quote($$event._1) + ")");
    case /* Event */9 :
        return "Event(" + (DOM__EventType$SmartcutsMacros.tToJs($$event._0) + ", event)");
    case /* SyntheticEvent */10 :
        return "SyntheticEvent(" + (stringify$1($$event._0) + ")");
    
  }
}

var EventType;

exports.EventType = EventType;
exports.$$CustomEvent = $$CustomEvent;
exports.ScrollInfo = ScrollInfo;
exports.TypedEventTarget = TypedEventTarget;
exports.PositionRelToElement = PositionRelToElement;
exports.PositionRelToElementWithScrollInfo = PositionRelToElementWithScrollInfo;
exports.$$MouseEvent = $$MouseEvent;
exports.$$InputEvent = $$InputEvent;
exports.$$ClipboardEvent = $$ClipboardEvent;
exports.$$KeyboardEvent = $$KeyboardEvent;
exports.$$DragEvent = $$DragEvent;
exports.$$FocusEvent = $$FocusEvent;
exports.BlurEvent = BlurEvent;
exports.$$WheelEvent = $$WheelEvent;
exports.SyntheticEvent = SyntheticEvent;
exports.boundingClientRectGet = boundingClientRectGet;
exports.stringify = stringify$2;
/* Rect-SmartcutsMacros Not a pure module */
